import axios from "axios";

function sendPost(requestPath, data, tokenHeader, setData, setErrorMessage, setLoading = null, callback) {
    if (setLoading !== null) {
        setLoading(true);
    }
    const options = {
        method: 'post',
        url: requestPath,
        data: data,
        headers: {
            'Authorization': tokenHeader,
            'Content-Type': "application/json",
            'Accept': "application/json",
            'Access-Control-Allow-Origin': requestPath
        }
    };

    axios(options)
        .then(response => {
            if (setErrorMessage) {
                setErrorMessage(null);
            }
            if (setLoading) {
                setLoading(false);
            }
            if (setData) {
                setData(response.data);
            }
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            if (setLoading) {
                setLoading(false);
            }
            if (setErrorMessage) {
                if (typeof(error.response) !== 'undefined' && error.response.status === 401) {
                    setErrorMessage('Your entries do not match the credentials of an active user');
                } else {
                    setErrorMessage(error.message);
                }
            }
        });
}

export default sendPost;

